import * as React from 'react';
import { HEADER } from '../../utils/dataTrackingValues.js';
import { MegaMenu as MegaMenu$2, MegaMenuTitle, FeaturedContent } from './Header.styles.js';

var MegaMenu = function MegaMenu(_ref) {
  var data = _ref.data,
    _ref$Link = _ref.Link,
    Link = _ref$Link === void 0 ? null : _ref$Link,
    _ref$featuredContent = _ref.featuredContent,
    featuredContent = _ref$featuredContent === void 0 ? null : _ref$featuredContent;
  return /*#__PURE__*/React.createElement(MegaMenu$2, null, /*#__PURE__*/React.createElement("div", {
    className: "subnav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "subnav-container"
  }, /*#__PURE__*/React.createElement(MegaMenuTitle, null, data.text), /*#__PURE__*/React.createElement("ul", null, data.subnav.map(function (subitem) {
    var nav = (subitem === null || subitem === void 0 ? void 0 : subitem.megaLinks) || subitem.subnav;
    return nav ? /*#__PURE__*/React.createElement("div", {
      key: subitem.text
    }, /*#__PURE__*/React.createElement("span", {
      className: "mega-menu-subheading"
    }, /*#__PURE__*/React.createElement(Link, {
      to: (subitem === null || subitem === void 0 ? void 0 : subitem.link) || subitem.href,
      onClick: function onClick() {
        return HEADER.LINKS.handleClick(subitem.text, (subitem === null || subitem === void 0 ? void 0 : subitem.link) || subitem.href);
      }
      // eslint-disable-next-line react/jsx-curly-newline
    }, subitem.text)), nav.map(function (item) {
      return /*#__PURE__*/React.createElement("li", {
        key: item.text
      }, /*#__PURE__*/React.createElement(Link, {
        to: (item === null || item === void 0 ? void 0 : item.link) || item.href,
        onClick: function onClick() {
          return HEADER.LINKS.handleClick(subitem.text, (subitem === null || subitem === void 0 ? void 0 : subitem.link) || subitem.href);
        }
        // eslint-disable-next-line react/jsx-curly-newline
      }, item.text));
    })) : /*#__PURE__*/React.createElement("li", {
      key: subitem.text
    }, /*#__PURE__*/React.createElement(Link, {
      to: (subitem === null || subitem === void 0 ? void 0 : subitem.link) || subitem.href,
      onClick: function onClick() {
        return HEADER.LINKS.handleClick(subitem.text, (subitem === null || subitem === void 0 ? void 0 : subitem.link) || subitem.href);
      }
      // eslint-disable-next-line react/jsx-curly-newline
    }, subitem.text));
  }))), featuredContent && /*#__PURE__*/React.createElement(FeaturedContent, null, featuredContent)));
};
var MegaMenu$1 = MegaMenu;

export { MegaMenu$1 as default };
//# sourceMappingURL=MegaMenu.js.map
